import React from 'react';

/**
 * Envuelve un bloque de la landing. Hoy NO anima: pinta el contenido en su
 * lugar, puesto desde el primer cuadro.
 *
 *
 * POR QUÉ SE SACÓ LA ANIMACIÓN DE ENTRADA
 *
 * Cada bloque nacía invisible (`opacity: 0`) y se encendía cuando el observador
 * de framer avisaba que había entrado en pantalla. Un IntersectionObserver avisa
 * DESPUÉS del primer pintado, nunca antes: por eso al cargar la página se veía
 * todo apagado y encendiéndose de a un bloque por vez, de arriba hacia abajo,
 * como un escáner recorriendo la página. El escalonado de `orden` sumaba a lo
 * mismo, porque separaba a propósito a los hermanos entre sí.
 *
 * No era cuestión de bajar los tiempos ni de agrandar el margen del observador:
 * mientras la entrada dependa de que algo avise después de pintar, siempre va a
 * haber un tramo en el que el contenido está puesto y no se ve, y ese tramo es
 * el parpadeo. Lo que se probó antes —margen de media ventana, `amount` al 5%,
 * el corte del escalonado en el cuarto hermano y el atajo de poner sin animar lo
 * que el scroll ya había pasado— achicaba el tramo, no lo eliminaba.
 *
 * Se deja el componente en lugar de sacarlo de los ~20 lugares que lo usan, y se
 * le dejan los nombres de los props para no tocar ninguno de esos llamados. Si
 * la entrada vuelve alguna vez, vuelve acá adentro y en un solo lugar, que es la
 * razón por la que este componente existe: antes había cinco fundidos escritos a
 * mano con cinco duraciones distintas.
 *
 * `como` sigue haciendo lo de siempre: que el elemento sea el correcto para el
 * contenido —section, article, li— en vez de meter un div de más.
 */
export default function Aparecer({
  // Sin animación no tienen nada que hacer, pero se aceptan y se descartan acá
  // para que no terminen en el DOM como atributos inventados.
  orden,
  desplazamiento,
  como = 'div',
  className,
  children,
  ...resto
}) {
  return React.createElement(como, { className, ...resto }, children);
}
